import { Box, Text } from "@chakra-ui/react";
import React from "react";
import Footer from "../../SharePages/Footer/Footer";
import FooterLR from "../FooterLR/FooterLR";
import Navbar from "../Navbar/Navbar";

const AboutUs = () => {
  window.scrollTo(0, 0);
  return (
    <>
      <Navbar></Navbar>
      <div className="container my-5 pb-5">
        <div className="row text-justify">
          <div className="col-lg-12 ">
            <Text fontWeight={700} fontSize="20px" pb={"15px"}>
              About Us
            </Text>
          </div>

          <Box>
            <Text pb={"20px"}>
              Travelchamp Limited began its operations on November 17, 2022,
              with a vision to redefine air travel convenience through
              innovation, trust, and excellence. We are dedicated to making air
              travel simpler, smarter, and more accessible for everyone. As an
              IATA-accredited travel company (IATA No: 42343162), Travelchamp
              Limited provides seamless and reliable flight booking services
              powered by advanced technology and a customer-first approach. Our
              team ensures a smooth and transparent booking experience for every
              traveler.
            </Text>

            <Text pb={"40px"}>
              With a commitment to service excellence, Travelchamp Limited
              offers 24/7 customer support, ensuring assistance whenever and
              wherever it’s needed. Built on the values of reliability and
              dedication, we continue to grow as one of Bangladesh’s trusted
              names in air travel—making every journey effortless and
              worry-free.
              {/* , intending to provide you with everything for
              a hassle-free tour. Incorporating deals with worldwide hotels and
              airlines, Travelchamp Limited makes it convenient to prepare for
              your travels, minimize your expenses, and highlights valuable
              insights. */}
            </Text>

            {/* <Text pb={"20px"}>
              Travelchamp Limited will offer services for booking hotels,
              airplanes, and tour reservations. Through commitments to tailored
              and top-notch services, Travelchamp will make every attempt to
              develop innovative traveling arrangements. Holiday and corporate
              clients can learn about, connect with, and book a wide range of
              services specialized to their travel preferences by exploring
              Travelchamp’s website. In all phases of the customers'
              journeys—before, throughout, and even after, it provides amicable
              assistance.
            </Text> */}

            {/* <Text pb={"200px"}>
              With the ambition of becoming recognized as a portrait of
              reliability, cutting-edge technology, and dedication to travel
              management, Travelchamp Limited approaches the travel industry.
            </Text> */}
          </Box>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
};

export default AboutUs;
